import $ from 'jquery';

function DrawRectangle() {
  const mobileapp = document.getElementById('mobileapp');
  if (!mobileapp) return;

  function drawLine(container = null, lineobject = null) {
    if (!container || !lineobject) return;
    let length = 0;
    const line = lineobject;
    const pathLength = line.getTotalLength();
    const distanceFromTop = (container.offset().top - $(window).scrollTop()) - 50;
    const percentDone = 1 - (distanceFromTop / $(window).height());
    length = percentDone * pathLength;
    line.style.strokeDasharray = [length, pathLength].join(' ');
  }

  function drawLines() {
    $.each($('path'), (i, val) => {
      const line = val;
      drawLine($('path'), line);
    });
  }

  if ($('.wrapper-h1').length > 0) {
    $(window).scroll(() => {
      const scrolTop = $(window).scrollTop();
      if ($('.wrapper-h1').offset() !== undefined) {
        const offset_t = scrolTop - $('.wrapper-h1').offset().top;
        if (scrolTop > offset_t) {
          drawLines();
        }
      }
    });
  }
}

export default DrawRectangle;
